import { render } from "./HomePart5.vue?vue&type=template&id=2bee757a&scoped=true&ts=true"
import script from "./HomePart5.vue?vue&type=script&lang=ts"
export * from "./HomePart5.vue?vue&type=script&lang=ts"

import "./HomePart5.vue?vue&type=style&index=0&id=2bee757a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bee757a"]])

export default __exports__